<template lang="pug">
  div(ref="container" :style="`width:100%; height:100%; min-height:${height}`")
    v-chart(:options="innerOptions" :height="height" :autoresize="true")
</template>

<script>
import $ from "jquery";
import ECharts from "./echart";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";

import "echarts-gl";

export default {
  name: "b-chart-bar",
  props: ["data", "columns", "labels", "options", "colors"],
  data() {
    return {};
  },
  computed: {
    height() {
      return `${this.options.height || "650px"}`;
    },
    serie_type() {
      if (
        ["line-simple", "area-stack", "area-basic"].includes(
          this.$props.options.type
        )
      )
        return "line";
      else if (
        ["bar-100", "bar-stacked", "bar-simple"].includes(
          this.$props.options.type
        )
      )
        return "bar";
      return this.$props.options.type;
    },
    accepts_cero_as_value() {
      return ["bar-100", "bar-stacked"].indexOf(this.$props.options.type) > -1;
    },
    y_axis_legend_max_value() {
      let y_axis_legend_max_value =
        this.$props.options.type === "bar-100" ? 100 : null;

      if (this.$props.options.type !== "bar-100") {
        let max_stackable = this.processed_data.series[0].data.map(_ => 0);
        let is_stackable = false;

        for (let i in this.processed_data.series) {
          let series = this.processed_data.series[i];

          if (i == 0) {
            is_stackable = series.stack ? true : false;
          }

          for (let i in series.data) {
            if (is_stackable) max_stackable[i] += series.data[i];
            else if (series.data[i] > y_axis_legend_max_value)
              y_axis_legend_max_value = series.data[i];
          }

          if (is_stackable) {
            for (let i in series.data) {
              if (max_stackable[i] > y_axis_legend_max_value)
                y_axis_legend_max_value = max_stackable[i];
            }
          }
        }
      }

      return y_axis_legend_max_value;
    },
    x_axis_legend_rotation() {
      let { labels } = this.processed_data;
      const Y_AXIS_LEGEN_MAX_VALUE = (
        this.y_axis_legend_max_value || 0
      ).toLocaleString("es-PY").length;

      let canvas_width
      if(this.$refs.container == null){
        canvas_width = $(window).width();
      }else{
        canvas_width = this.$refs.container.clientWidth;
      }

      const Y_AXIS_MAX_LENGTH = 4 + Y_AXIS_LEGEN_MAX_VALUE;
      const MAX_LENGTH = 0.1 * (canvas_width - Y_AXIS_MAX_LENGTH);
      const MAX_COL_LENGTH = Math.floor(MAX_LENGTH / labels.length);

      for (let value of labels) {
        if (value && `${value}`.length > MAX_COL_LENGTH) return 90;
      }

      return 0;
    },
    processed_data() {
      let series = [];
      let totals = [];
      let labels = this.labels.slice(0);
      let y_name = null;

      this.$props.data.forEach(row => {
        let dataIndex = this.labels.indexOf(row.label);
        let serieIndex = this.columns.indexOf(row.description);

        if (!series[serieIndex])
          series[serieIndex] = this.format(
            {
              data: [],
              name: row.description
            },
            this.accepts_cero_as_value
          );

        if (row.is_grupable) {
          if (!series[serieIndex].data[dataIndex])
            series[serieIndex].data[dataIndex] = 0;
          series[serieIndex].data[dataIndex] += row.value;
        } else {
          series[serieIndex].data[dataIndex] = row.value;
        }

        if (!totals[dataIndex]) totals[dataIndex] = 0;
        totals[dataIndex] += row.value;
      });

      for (let i = labels.length - 1; i >= 0; i--) {
        let isEmpty = true;
        for (let serie of series) {
          if (
            serie.data[i] ||
            (this.accepts_cero_as_value && serie.data[i] === 0)
          ) {
            isEmpty = false;
            break;
          }
        }

        if (isEmpty) {
          series.forEach(row => row.data.splice(i, 1));
          labels.splice(i, 1);
          totals.splice(i, 1);
        }
      }

      return {
        labels,
        series,
        y_name,
        totals
      };
    },
    innerOptions() {
      if (
        !this.processed_data.series ||
        this.processed_data.series.length === 0
      )
        return {};
      let y_axis_legend_max_value =
        this.$props.options.type === "bar-100" ? 100 : null;

      if (this.$props.options.type === "bar-100") {
        for (let i in this.processed_data.series) {
          for (let j in this.processed_data.series[i].data) {
            this.processed_data.series[i].data[j] =
              (this.processed_data.series[i].data[j] * 100) /
              this.processed_data.totals[j];
          }
        }
      } else {
        let max_stackable = this.processed_data.series[0].data.map(_ => 0);
        let is_stackable = false;

        for (let i in this.processed_data.series) {
          let series = this.processed_data.series[i];

          if (i == 0) {
            is_stackable = series.stack ? true : false;
          }

          for (let i in series.data) {
            if (is_stackable) max_stackable[i] += series.data[i];
            else if (series.data[i] > y_axis_legend_max_value)
              y_axis_legend_max_value = series.data[i];
          }

          if (is_stackable) {
            for (let i in series.data) {
              if (max_stackable[i] > y_axis_legend_max_value)
                y_axis_legend_max_value = max_stackable[i];
            }
          }
        }
      }

			console.log(this.$props.colors)

      return {
							color: this.$props.colors,
							title: {
								text: `{titleIndicator|${this.$props.options.showTitle ? this.$props.options.title : null}}`,
								show: this.options.show_title ? true : false,
								textStyle: {
									width: this.$root.isMobile() ? 300 : 600,
									overflow: 'break',
									rich: {
										titleIndicator: {
											color: "#346899",
											fontSize: 16,
											fontWeight: 500,
											align: 'center'
										}
									}
								},
								top: "0",
								left: "center"
							},

							grid: {
								top: this.$root.isMobile() ? "20%" : "17%",
								left: "5%",
								right: "3%",
								bottom: "65",
								containLabel: true
							},
							backgroundColor: this.$props.options.backgroundColor,
							footer: this.$props.options.footer,
							legend: {
								orient: "horizontal",
								right: "3%",
								top: 55,
								bottom: 20
							},

							tooltip: {
								trigger: "item",
								formatter: params => {
									let prefix = this.$props.options.prefix || "";
									let suffix = this.$props.options.suffix || "";
									let label = params[params.$vars[0]];
									let value = `${prefix} ${params[params.$vars[2]].toLocaleString(
										"es-PY"
									)} ${suffix}`;
									let result = `${label}: ${value}`;
									if (!this.$props.options.hide_total_tooltip) {
										let total = `${prefix} ${this.processed_data.totals[
											params.dataIndex
										].toLocaleString("es-PY")} ${suffix}`;
										return `${result} <br>Total: ${total}`;
									} else return result;
								}
							},

							xAxis: {
								type: "category",
								data: this.processed_data.labels,
								axisLabel: {
									rotate: this.x_axis_legend_rotation
								}
							},

							yAxis: {
								name: this.$props.options.y_title || this.processed_data.y_name,
								nameGap: 30,
								axisLabel: {
									formatter: value => value.toLocaleString("es-PY")
								},
								max:
									this.$props.options.type === "bar-100"
										? 100
										: this.$props.options.max_value,
								nameLocation: "middle",
								nameRotate: 90,
								nameGap: `${Math.ceil(y_axis_legend_max_value)}`.length * 9 + 10,
								axisLine: {
									show: false
								}
							},
							series: this.processed_data.series,
							animationDuration: 2000
      };
    }
  },
  methods: {
    format(serie, stackable) {
      serie.type = this.serie_type;
      if (stackable && this.$props.options.type !== "area-basic")
        serie.stack = "stack";
      if (["area-stack", "area-basic"].indexOf(this.$props.options.type) > -1)
        serie.areaStyle = {};
      return serie;
    }
  },
  components: {
    "v-chart": ECharts
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// bar.vue